import { ON_FORM_ERROR_METADATA_KEY } from './metadata-keys';
import { addToMetadata } from '@digitaix/helpers';

export function OnFormError(order: number = -1) {
  return function(
    target: any,
    propertyKey: string
  ) {
    addToMetadata(
      ON_FORM_ERROR_METADATA_KEY,
      {
        order,
        propertyKey
      },
      target
    );
  };
}
